module.exports = __webpack_public_path__ + "img/hybris.30023878.svg";